import { requestCreateSearchBrief } from '@src/services/api'

export const addRecaptchaDataToken = async values => {
  const form = document.getElementById('brief-create-form')
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  // eslint-disable-next-line
  const token = await grecaptcha.execute(form.getAttribute('data-captcha-id'), { action: form.getAttribute('data-recaptcha-action') || 'recaptcha_action' })

  return await requestCreateSearchBrief({
    ...values,
    recaptchaResponse: token
  })
}
